import React from 'react';
import { useTranslation } from 'react-i18next';
import ButtonComponent from './ButtonMC';
import sendErrorImage from 'images/send-error.png';

/**
 * ReportConfirmationScreenMC - A component to display after a user successfully reports an error.
 * Shows a confirmation message and provides an option to go back to the dashboard.
 *
 * @param {Object} props - The component props.
 * @param {function} props.onBackToDashboard - Callback function to navigate back to dashboard.
 * @returns {JSX.Element} The rendered confirmation screen component.
 */
const ReportConfirmationScreenMC = ({ onBackToDashboard }) => {
  const { t } = useTranslation('ErrorScreensMC');

  return (
    <div className="tw-wrapper">
      <div 
        className="md:tw-ml-[60px] tw-min-h-[calc(100vh-60px)] tw-flex tw-flex-col tw-items-center tw-justify-center tw-px-4"
        style={{ background: 'linear-gradient(180deg, #FFF 55.1%, #EAFEFF 100%)' }}
      >
        {/* Título */}
        <h1 className="tw-text-3xl tw-font-semibold tw-text-blue-500 tw-mb-4 tw-text-center">
          {t('report_confirmation.title')}
        </h1>

        {/* Descripción */}
        <p className="tw-text-gray-700 tw-mb-6 tw-text-base tw-text-center tw-max-w-lg">
          {t('report_confirmation.description')}
        </p>

        {/* Imagen de confirmación */}
        <div className="tw-flex tw-justify-center tw-mb-8">
          <img 
            src={sendErrorImage} 
            alt="Reporte enviado" 
            className="tw-w-44 tw-h-auto"
          />
        </div>

        {/* Botón */}
        <ButtonComponent
          text={t('report_confirmation.back_to_dashboard')}
          variant="PRIMARY"
          onClick={onBackToDashboard}
          size="medium"
        />
      </div>
    </div>
  );
};

export default ReportConfirmationScreenMC;
